import { Box, Button, Flex, Grid, NumberInput, TextInput } from "@mantine/core";
import { useForm } from "@mantine/form";
import { useDisclosure } from "@mantine/hooks";
import { IconCheck } from "@tabler/icons-react";
import {
  repositoryMdm,
  repositoryPos,
} from "../../../../_base/_const/_constVar";
import { MessageResponse } from "../../../../model/MessageResponse";
import { NotificationExtension } from "../../../../_base/extension/NotificationExtension";
import { modals } from "@mantine/modals";
import { useEffect } from "react";

interface DistanceFareModel {
  id: number;
  code: string | null;
  distance: number;
  value: number;
}

const CUDDistanceFare = ({
  data,
  onSuccess,
}: {
  data: any;
  onSuccess: any;
}) => {
  const [visible, { toggle, open, close }] = useDisclosure(false);

  const form = useForm<DistanceFareModel>({
    mode: "uncontrolled",
    validateInputOnChange: true,
    initialValues: {
      id: 0,
      code: null,
      distance: 0,
      value: 0,
    },

    validate: {
      code: (value: string | null) => {
        if (!value || value.length === 0) {
          return "Mã không được bỏ trống !";
        }
      },
      distance: (value: number) => {
        if (!value || value <= 0) {
          return "Quãng đường tính lương không được bỏ trống và phải lớn hơn 0 !";
        }
      },
      value: (value: number) => {
        if (!value || value <= 0) {
          return "Lương vận chuyển không được bỏ trống và phải lớn hơn 0 !";
        }
      },
    },
  });

  const handleCreate = async (dataSubmit: DistanceFareModel) => {
    open();
    try {
      const res = await repositoryPos.post<MessageResponse<any>>(
        "/api/v1/DistanceFare/create",
        dataSubmit,
      );

      if (res && res.success) {
        NotificationExtension.Success(
          "Thiết lập quãng đường tính lương thành công !",
        );
        setTimeout(() => {
          modals.closeAll();
          onSuccess();
        }, 1000);
      }
    } catch (error) {
      console.log(error);
    } finally {
      close();
    }
  };

  const handleUpdate = async (dataSubmit: DistanceFareModel) => {
    open();
    try {
      const res = await repositoryPos.post<MessageResponse<any>>(
        "/api/v1/DistanceFare/edit",
        dataSubmit,
      );

      if (res && res.success) {
        NotificationExtension.Success(
          "Thiết lập quãng đường tính lương thành công !",
        );
        setTimeout(() => {
          modals.closeAll();
          onSuccess();
        }, 1000);
      }
    } catch (error) {
      console.log(error);
    } finally {
      close();
    }
  };

  useEffect(() => {
    if (data) {
      form.setValues(data);
    }
  }, [data]);

  return (
    <Box
      mt={5}
      component="form"
      onSubmit={form.onSubmit((e: DistanceFareModel) => {
        if (data) {
          handleUpdate(e);
        } else {
          handleCreate(e);
        }
      })}
    >
      <Grid>
        <Grid.Col span={12}>
          <TextInput
            key={form.key("code")}
            label="Mã"
            placeholder="Nhập mã"
            withAsterisk
            variant={data ? "filled" : "default"}
            readOnly={data}
            {...form.getInputProps("code")}
          />
        </Grid.Col>
        <Grid.Col span={12}>
          <NumberInput
            key={form.key("distance")}
            label="Quãng đường tính lương (km)"
            placeholder="Nhập quãng đường tính lương"
            withAsterisk
            hideControls
            allowNegative={false}
            suffix=" km"
            {...form.getInputProps("distance")}
          />
        </Grid.Col>
        <Grid.Col span={12}>
          <NumberInput
            key={form.key("value")}
            label="Lương vận chuyển"
            placeholder="Nhập lương vận chuyển"
            withAsterisk
            hideControls
            allowNegative={false}
            suffix=" VNĐ"
            {...form.getInputProps("value")}
          />
        </Grid.Col>
      </Grid>
      <Flex justify={"center"} align={"center"} mt={5}>
        <Button
          leftSection={<IconCheck size={18} />}
          color="teal"
          type="submit"
          disabled={visible}
          loading={visible}
        >
          Lưu
        </Button>
      </Flex>
    </Box>
  );
};

export default CUDDistanceFare;
